import { ENV } from './envConfig';

// eslint-disable-next-line import/prefer-default-export
export const baseUrl = ENV.VITE_BASE_URL || import.meta.env.VITE_BASE_URL;
